import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { selectVoucher } from '../../../../cartAndOrders/store/slice'
import { Element } from '../../../../common/html/element'
import { Icon } from '../../../../common/html/icon'
import { Popup } from '../../../../common/popup'
import classes from '../../../index.module.scss'
import {
  changeKeyCheckValidVolume,
  changeSubscriptionDetailsParams,
  selectBuyPackage,
  selectSubscriptionPricing,
  setSubscriptionPrice,
} from '../../store/slice'
import { getSubscriptionPricings } from '../../store/thunk'
import { getSubscriptionByType } from '../helper'
import '../lang/i18n'
import { GroupButton } from '../popupBuyPackage/common/GroupButton'
import { useGetDiscountDouble } from '../useGetDiscountDouble'
import { SubscriptionForm } from './SubscriptionForm'
import { SUBSCRIPTION_TERMS_KEYS, SUBSCRIPTION_TYPES_KEYS } from './constants'

export const PopupUpgradeAccount = ({
  isShow,
  setIsShow,
  isDefaultSelectPremium,
  setIsOpenBuyNow,
  userProfile,
  loadingUserProfile,
  isBuyPackage,
  setIsBuyPackage,
}) => {
  const dispatch = useDispatch()
  const { discountSub, discountPackage } = useGetDiscountDouble()

  const [subscriptionType, setSubscriptionType] = useState(
    SUBSCRIPTION_TYPES_KEYS.STANDARD,
  )
  const [subscriptionTerm, setSubscriptionTerm] = useState(
    SUBSCRIPTION_TERMS_KEYS.THREE_MONTHS,
  )

  const dataVoucher = useSelector(selectVoucher)
  const subscriptionPricing = useSelector(selectSubscriptionPricing)
  const buyPackage = useSelector(selectBuyPackage)

  const listPackage = buyPackage?.listPackage
  const subscriptionItem = getSubscriptionByType(
    subscriptionPricing,
    subscriptionType,
    subscriptionTerm,
  )

  const subscriptionDetails = {
    dataPackageId: subscriptionType,
    months: subscriptionTerm,
    discountId: discountSub?.id,
    price: subscriptionItem?.price,
    voucherCode: dataVoucher?.code,
  }

  const handleClose = () => {
    setIsShow(false)
  }

  const updateSubscriptionDetailsParams = () => {
    dispatch(changeSubscriptionDetailsParams(subscriptionDetails))
  }

  const buyNow = () => {
    if (isBuyPackage) {
      dispatch(changeKeyCheckValidVolume())
      if (listPackage?.some((item) => !item.volume)) return
    }
    updateSubscriptionDetailsParams()
    setIsOpenBuyNow(true)
    setIsShow(false)
  }

  useEffect(() => {
    if (isDefaultSelectPremium) {
      setSubscriptionType(SUBSCRIPTION_TYPES_KEYS.PREMIUM)
    }
  }, [isDefaultSelectPremium])

  useEffect(() => {
    dispatch(setSubscriptionPrice(subscriptionItem?.price))
  }, [subscriptionItem?.price])

  useEffect(() => {
    dispatch(getSubscriptionPricings({}))
  }, [])

  return (
    <>
      {isShow && (
        <Popup
          zIndexPopup={99}
          appendStyleContent={{
            padding: 20,
            backgroundColor: '#F3F3F3',
            borderRadius: '4px',
            width: 650,
          }}
        >
          <div className={[classes.popupBuyPackage].join(' ')}>
            <Element
              className={[
                'dFlex justifyContentBetween alignItemsCenter',
                classes.header,
              ].join(' ')}
              style={{
                borderBottom: '1px solid #e5e5e8',
              }}
            >
              <Element
                elementName="span"
                style={{
                  fontSize: 20,
                  fontWeight: 500,
                  lineHeight: '24px',
                  color: '#0553A5',
                  width: `calc(100% - 30px)`,
                }}
              >
                <Translate value="userManagement.upgradeAccount.UPGRADE" />
              </Element>
              <Element onClick={handleClose}>
                <Icon
                  className="icon-delete"
                  style={{ fontSize: 12, color: '#9C9C9C' }}
                />
              </Element>
            </Element>
            <SubscriptionForm
              subscriptionType={subscriptionType}
              setSubscriptionType={setSubscriptionType}
              subscriptionTerm={subscriptionTerm}
              setSubscriptionTerm={setSubscriptionTerm}
              oldPrice={null}
              discountedPrice={subscriptionItem?.price}
              isBuyPackage={isBuyPackage}
              setIsBuyPackage={setIsBuyPackage}
              discountSub={discountSub}
              discountPackage={discountPackage}
            />
          </div>
          <div className="dFlex justifyContentEnd">
            <GroupButton
              subscriptionDetails={subscriptionDetails}
              isBuyPackage={isBuyPackage}
              buyNow={buyNow}
              userProfile={userProfile}
              loadingUserProfile={loadingUserProfile}
              updateSubscriptionDetailsParams={updateSubscriptionDetailsParams}
            />
          </div>
        </Popup>
      )}
    </>
  )
}
